import { render } from "./Volumes.vue?vue&type=template&id=b51aaccc&scoped=true"
import script from "./Volumes.vue?vue&type=script&lang=js"
export * from "./Volumes.vue?vue&type=script&lang=js"

import "./Volumes.vue?vue&type=style&index=0&id=b51aaccc&scoped=true&lang=css"

import exportComponent from "/usr/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b51aaccc"]])

export default __exports__